/**
 * Type definitions for MCQ Quiz components.
 * Re-exports Orval-generated types for the student quiz view.
 */

export type { MCQStudentOption as MCQOption } from '@/common/api/models';
export type { MCQStudentQuestion as MCQQuestion } from '@/common/api/models';

export interface MCQAttemptResult {
  score: number;
  maxScore: number;
  passed: boolean;
  correctAnswers?: Record<string, string>;
  feedback?: Record<string, string>;
}

export type QuizState = 'loading' | 'ready' | 'submitted' | 'error' | 'waiting_for_exam' | 'exam_closed';
